import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onls-title" }

import { useRouter } from "vue-router";
import SmallArrowRightIcon from "@/components/small-arrow-right-icon.vue";
import ArrowRightIcon from "@/components/arrow-right-icon.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'onls-title-back',
  props: {
  title: { type: String, required: true },
  customRedirect: { type: Boolean, default: false },
},
  emits: ["back"],
  setup(__props, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line no-undef
const emits = __emit;
const router = useRouter();
const returnBack = () => {
  if (props.customRedirect) {
    emits("back");
    return;
  }

  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "onls-title-back",
      onClick: returnBack
    }, [
      _createVNode(ArrowRightIcon),
      _createVNode(SmallArrowRightIcon),
      _createElementVNode("div", null, _toDisplayString(__props.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "append")
  ]))
}
}

})